"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSwitchingAllowed = isSwitchingAllowed;
exports.isAddPointsAllowed = isAddPointsAllowed;
exports.shouldShowPoints = shouldShowPoints;
exports.shouldShowRefillInXDays = shouldShowRefillInXDays;
exports.isSwitchingToUUNotAllowed = isSwitchingToUUNotAllowed;
exports.isForumLink = isForumLink;

var _config = require("../config");

function isSwitchingAllowed(planId) {
  var notAllowedFor = ["unreal-unlimited", "education-4K-quarterly", "education-4K-biannual", "education-4K-annual", "personal-monthly", "personal-annual", "indie-monthly", "indie-annual", "pro-monthly", "pro-annual", "custom", "studio"];

  var foundInNotAllowedFor = notAllowedFor.find(function (id) {
    return id === planId;
  });
  var allowed = !foundInNotAllowedFor;
  return allowed;
}

function isAddPointsAllowed(planId) {
  var allowedFor = ["personal-monthly", "personal-annual", "indie-monthly", "indie-annual", "pro-monthly", "pro-annual"];

  var foundInAllowedFor = allowedFor.find(function (id) {
    return id === planId;
  });
  return foundInAllowedFor;
}

function shouldShowPoints(planId) {
  var notShownTo = ["unreal-unlimited"];

  var foundInNotShownTo = notShownTo.find(function (id) {
    return id === planId;
  });
  var show = !foundInNotShownTo;
  return show;
}

function shouldShowRefillInXDays(planId) {
  var notShownTo = ["education-4K-quarterly", "education-4K-biannual", "education-4K-annual"];

  var foundInNotShownTo = notShownTo.find(function (id) {
    return id === planId;
  });
  var show = !foundInNotShownTo;
  return show;
}

function isSwitchingToUUNotAllowed(subscription) {
  return subscription && subscription.status === "active" && subscription.isActive === true && subscription.doesGetCharged === false;
}

function isForumLink(link) {
  return link.indexOf(_config.forumBaseUrl) > -1;
}


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/utils.js
// module id = 161
// module chunks = 0